import { Button } from 'primereact/button';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import useFileDownload from '../../hooks/useFileDownload';
import SearchInput from '../SearchInput';
import { PurchasePriceFilterProps } from '../types/types';

type Props = {
  loading?: boolean;
  filters?: PurchasePriceFilterProps;
  onChangeSearch(event: ChangeEvent<HTMLInputElement>): void;
};

export default function PurchasePriceFilters({
  loading,
  filters,
  onChangeSearch,
}: Props) {
  const { t, i18n } = useTranslation();

  const handleDownloadResponse = (file: File) => {
    const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const tempLink = document.createElement('a');
    tempLink.href = window.URL.createObjectURL(blob);
    tempLink.download = `report_${new Date().toISOString().slice(0, 10)}.xlsx`;
    tempLink.click();
  };

  const { onDownload } = useFileDownload({
    callback: handleDownloadResponse,
    url: `/purchase-prices/export?locale=${i18n.language}`,
  });

  return (
    <div className="flex flex-wrap justify-content-between gap-3 mb-3">
      <div className="flex-1">
        <SearchInput
          placeholder={t('products.label-search-products')}
          loading={loading}
          value={filters?.search}
          onChange={onChangeSearch}
          style={{ height: '50px', minWidth: '16rem' }}
        />
      </div>
      <Button
        label={t('common.cmd-export')}
        size="small"
        outlined
        type="button"
        icon="pi pi-file-export"
        onClick={onDownload}
      />
    </div>
  );
}
